import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { formatShootDate, isUpcoming, shootDay, shootMonth, shootYear } from '../../utils/time';
export function Schedule() {
  const {
    activeProject
  } = usePortal();
  const upcoming = [...activeProject.shoots].filter(shoot => isUpcoming(shoot.date)).sort((a, b) => a.date.localeCompare(b.date));
  const fallbackDate = isUpcoming(activeProject.nextShootDate) ? activeProject.nextShootDate : '';
  return <div data-id="element-674" data-mp="1nvm8dflfqok8">
      <h1 className="font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-675" data-mp="1nvduplhhnf7z">SCHEDULE</h1>
      <p className="label mt-8 text-mute" data-id="element-676" data-mp="1a4h9ifpw60ay">Upcoming</p>

      {upcoming.length === 0 ? <div className="mt-10 border-y border-rule py-12" data-id="element-677" data-mp="1f3286aphwbxa">
          <p className="font-display text-3xl leading-tight" data-id="element-678" data-mp="1f1hdml36kszf">
            {fallbackDate ? formatShootDate(fallbackDate) : 'To be confirmed'}
          </p>
          {fallbackDate && (activeProject.nextShootTime || activeProject.location) && <p className="mt-4 font-display text-xl text-charcoal" data-id="element-679" data-mp="3uqkf89k1fp57">
              {[activeProject.nextShootTime, activeProject.location].filter(Boolean).join(' · ')}
            </p>}
          <p className="mt-6 max-w-lg font-display text-lg text-graphite" data-id="element-680" data-mp="8azf9egf852r">
            Portal will confirm the full call sheet closer to the date.
          </p>
        </div> : <ul className="m-0 mt-10 list-none border-t border-rule p-0" data-id="element-681" data-mp="3ipwcidq459z">
          {upcoming.map((shoot, index) => <li key={shoot.id} className="border-b border-rule py-12" data-id="element-682" data-mp="dam28fm1wzor" data-mpi={index}>
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-683" data-mp="dcgi3figu1lz">
                <div className="lg:col-span-3" data-id="element-684" data-mp="r9c1a0sfl9fr">
                  <p className="font-display text-6xl leading-none tracking-tight sm:text-7xl" data-id="element-685" data-mp="mains8d59ifl">
                    {shootDay(shoot.date)}
                  </p>
                  <p className="label mt-4 text-mute" data-id="element-686" data-mp="2t3ks1fsz2fjw">
                    {shootMonth(shoot.date)} {shootYear(shoot.date)}
                  </p>
                </div>

                <div className="lg:col-span-6" data-id="element-687" data-mp="s0k6qtqvpo81">
                  <h2 className="font-display text-3xl leading-tight sm:text-4xl" data-id="element-688" data-mp="wyc0ltb33kev">
                    {shoot.title.toUpperCase()}
                  </h2>
                  <p className="mt-4 font-display text-xl text-charcoal" data-id="element-689" data-mp="11wn5dpmiv4q8">
                    {[formatShootDate(shoot.date), shoot.time, shoot.city].filter(Boolean).join(' · ')}
                  </p>
                  {shoot.location && <p className="label mt-5 text-mute" data-id="element-690" data-mp="1fwo7f8eiwi7a">{shoot.location}</p>}
                  {index === 0 && activeProject.callSheet && <a href={activeProject.callSheet.url} target="_blank" rel="noreferrer" className="label mt-9 inline-block border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-691" data-mp="1kog1hsww1626">
                      View Call Sheet
                    </a>}
                </div>

                <dl className="m-0 lg:col-span-3" data-id="element-692" data-mp="3e6n3v7m072rj">
                  {shoot.details.map(detail => <div key={detail.label} className="flex items-baseline justify-between gap-4 border-b border-rule py-3 last:border-b-0" data-id="element-693" data-mp="3a4s2k342opdr">
                      <dt className="label m-0 text-mute" data-id="element-694" data-mp="5rd4i79i0bng">{detail.label}</dt>
                      <dd className="m-0 font-sans text-sm tracking-wide2 text-charcoal" data-id="element-695" data-mp="5sobsh25k1jb">
                        {detail.value}
                      </dd>
                    </div>)}
                </dl>
              </div>
            </li>)}
        </ul>}
    </div>;
}